import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';

export const Container = styled(Box)({
  width: '100%',
  maxWidth: '540px',
  margin: '0 auto',
  position: 'relative',
});

export const CrispIcon = styled(Box)(({ theme }) => ({
  position: 'absolute',
  bottom: '50px',
  right: '15px',
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '51px',
  height: '38px',
  zIndex: 1001,
  [`@media (max-width: ${theme.breakpoints.values.sm}px)`]: {
    right: '5px',
  },
}));

export const CrispIconText = styled('div')(({ theme }) => ({
  fontWeight: 400,
  fontSize: '13px',
  lineHeight: '22px',
  color: theme.palette.common.black,
  position: 'absolute',
  top: '8px',
}));

export const CrispIconRight = styled(Box)({
  transform: 'translateX(250px)',
});

export const CrispIconMobile = styled(Box)(({ theme }) => ({
  top: '20px',
  transform: 'translateX(0)',
  right: '10px',
  height: '40px',
  cursor: 'pointer',
  borderTopLeftRadius: '20px',
  borderBottomLeftRadius: '20px',
  borderBottomRightRadius: '20px',
  color: theme.palette.common.black,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontWeight: 600,
}));

export const MarginTop = styled(Box)({
  top: '60px',
});

export const MarginTop90 = styled(Box)({
  top: '90px',
});

export const VideoPosition = styled(Box)({
  top: '40px',
});

export const BottomPosition = styled(Box)({
  position: 'absolute',
  bottom: '45px',
  right: '20px',
});

export const Hidden = styled(Box)({
  display: 'none',
});
